import { Button } from "@/components/ui/button";
import { Phone, ArrowDown } from "lucide-react";
import { useState, useEffect } from "react";

export const Hero = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [currentText, setCurrentText] = useState(0);
  const texts = ["Firmowych", "Prywatnych", "Specjalnych"];

  useEffect(() => {
    const phoneInterval = setInterval(() => setShowPhone(prev => !prev), 3000);
    const textInterval = setInterval(() => setCurrentText(prev => (prev + 1) % texts.length), 4000);
    return () => { clearInterval(phoneInterval); clearInterval(textInterval); };
  }, []);

  const scrollToContactForm = () => {
    document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden section-darker">
      {/* Premium background image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/hero-bg.jpg)' }}
      />
      <div className="absolute inset-0 bg-background/80" />
      {/* Mesh gradient background */}
      <div className="absolute inset-0 mesh-gradient opacity-70" />
      
      {/* Animated orbs */}
      <div className="absolute w-[500px] h-[500px] rounded-full bg-primary/10 blur-[120px] -top-48 -left-48 animate-float" />
      <div className="absolute w-[400px] h-[400px] rounded-full bg-accent/8 blur-[100px] -bottom-32 -right-32 animate-float [animation-delay:1.5s]" />
      <div className="absolute w-[300px] h-[300px] rounded-full bg-[hsl(180,80%,60%)]/5 blur-[80px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-float [animation-delay:3s]" />

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(hsl(0 0% 100% / 0.1) 1px, transparent 1px), linear-gradient(90deg, hsl(0 0% 100% / 0.1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }} />

      <div className="container relative z-10 text-center px-4">
        <div className="inline-block mb-6 px-4 py-1.5 rounded-full glass text-sm text-muted-foreground">
          ✨ Profesjonalne występy artystyczne
        </div>
        
        <h1 className="font-space-grotesk text-5xl sm:text-6xl md:text-8xl font-bold mb-6 tracking-tight">
          <span className="text-foreground">Występy dla wydarzeń</span>
          <br />
          <span className="text-gradient animate-gradient-shift bg-[length:200%_200%]">
            {texts[currentText]}!
          </span>
        </h1>
        
        <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto text-muted-foreground leading-relaxed">
          Profesjonalne występy artystyczne dla firm i osób prywatnych,
          które sprawią, że Twoje wydarzenie będzie niezapomniane!
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            onClick={scrollToContactForm}
            className="bg-primary hover:bg-primary/80 text-primary-foreground text-lg px-8 py-6 rounded-xl glow transition-all duration-300 hover:scale-105 w-[240px] flex items-center justify-center gap-2"
          >
            {showPhone ? (
              <>
                <Phone className="w-5 h-5" />
                +48 533 333 993
              </>
            ) : (
              "Zamów występ"
            )}
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={scrollToAbout}
            className="border-border text-foreground hover:bg-secondary text-lg px-8 py-6 rounded-xl transition-all duration-300"
          >
            Dowiedz się więcej
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <button 
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-muted-foreground hover:text-foreground transition-colors animate-float"
      >
        <ArrowDown className="w-6 h-6" />
      </button>
    </div>
  );
};
